export default __webpack_public_path__ + "static/media/logo-vinho2.300e164f.png";